import { render, staticRenderFns } from "./security-questions.vue?vue&type=template&id=cce9ed6e&"
import script from "./security-questions.vue?vue&type=script&lang=js&"
export * from "./security-questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports